<div class="button-group" role="radiogroup">
  <label
    *ngFor="let option of options; let i = index"
    aria-checked="true"
    class="image_button"
    [attr.tabindex]="0"
    (mouseenter)="onMouseEnter(option)"
    (mouseleave)="onMouseLeave(option)"
    (click)="onClick(option)"
    role="radio"
  >
    <div
      class="inner_container"
      [class.inner_container__selected]="selectedValue === option.value"
    >
      <input
        [attr.tabindex]="-1"
        type="radio"
        [value]="option"
        [formControl]="buttonCtrl"
      />
      <img class="image-size-small" [src]="option.currentMobileImage" alt="" />
      <img class="image-size-medium" [src]="option.currentImage" alt="" />
      <span
        class="option__text"
        [class.option__text__selected]="selectedValue === option.value"
        >{{ option.text }}</span
      >
    </div>
  </label>
</div>
